import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

/** Emphasises the part of an option's label that the search text matched. */
@Component({
    selector: 'pulse-combobox-match',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `{{ parts().before }}<b>{{ parts().match }}</b
        >{{ parts().after }}`,
    styles: `
        b {
            font-weight: var(--font-weight-semibold);
        }
    `,
})
export class PulseComboboxMatchComponent {
    readonly text = input.required<string>();

    readonly query = input('');

    protected readonly parts = computed(() => {
        const text = this.text();
        const query = this.query().trim();
        const start = query === '' ? -1 : text.toLowerCase().indexOf(query.toLowerCase());
        if (start === -1) {
            return { before: text, match: '', after: '' };
        }
        return {
            before: text.slice(0, start),
            match: text.slice(start, start + query.length),
            after: text.slice(start + query.length),
        };
    });
}
